import {json, JsonMappers} from '../core/data-source/json.mapper';

export class VehicleRequirementRecord {
    @json() id: number;

    @json() name: string;

    @json() abbreviation: string;

    @json() selected: boolean;

    @json({
        skip: true,
        jsonName: 'incompatibleTypes',
        mapper: {
            from: (data: any[]): string => data.map((item: any) => item.name).join(', ')
        }
    })
    incompatibleTypesStr: string;

    @json(JsonMappers.ArrayOf(() => VehicleRequirementRecord))
    incompatibleTypes: VehicleRequirementRecord[];
}
